import React, { useMemo } from 'react';
import styles from './UIGameTradeCreatorWantedCardSelector.module.scss';
import clsx from 'clsx';
import { CardDataController } from '@colonist/game-card-types';
import { CardEnum } from '@colonist/game-states';
import { UIGameTradeCreatorBankRatio } from '../UIGameTradeCreatorBankRatio/index.ts';
import { TradeErrorHighlightLocationEnum } from '@colonist/game-mechanic-validators';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useCardsToHighlight } from '../useCardsToHighlight.ts';
import { ArrayUtils } from '@colonist/utils';
import { ModeSettingEnum } from '@colonist/types';
import { UIGameCardInventory } from '../../../common/UIGameCardInventory/UIGameCardInventory.tsx';
import { cardEnumsToCardState } from '../../../utils/cards.ts';
export const UIGameTradeCreatorWantedCardSelector = ({ className, onAddCard, isPortraitLayout })=>{
    const gameModeData = useGameStore((state)=>state.gameMode);
    const isBankTradeMode = useGameStore((state)=>state.gameTrade.isBankTradeMode);
    const wantedCards = useGameStore((state)=>state.gameTrade.wantedCards);
    const beginnerHintData = useGameStore((state)=>state.gameBeginnerHint.beginnerHintData);
    const beginnerActionState = useGameStore((state)=>state.gameBeginnerHint.beginnerActionState);
    const isBeginnerMode = useGameStore((state)=>state.gameSettings.modeSetting == ModeSettingEnum.BeginnerModeClassic4P);
    const wantedResourcesSuggestion = useMemo(()=>{
        const suggestionWantedCards = (beginnerHintData === null || beginnerHintData === void 0 ? void 0 : beginnerHintData.data.wantedResources) != null ? beginnerHintData === null || beginnerHintData === void 0 ? void 0 : beginnerHintData.data.wantedResources : [];
        let remainingSuggestions = [
            ...suggestionWantedCards
        ];
        for (const wantedCard of wantedCards){
            remainingSuggestions = ArrayUtils.removeOneElement(remainingSuggestions, wantedCard);
        }
        return remainingSuggestions;
    }, [
        beginnerHintData,
        wantedCards
    ]);
    const shouldShowSuggestion = (beginnerHintData === null || beginnerHintData === void 0 ? void 0 : beginnerHintData.data.wantedResources) != null;
    const handleAddCard = (card)=>{
        if (shouldShowSuggestion && isBeginnerMode) {
            if (wantedResourcesSuggestion.includes(card)) onAddCard(card);
            return;
        }
        onAddCard(card);
    };
    const cardToDisplayState = useMemo(()=>{
        const activeCards = CardDataController.getCardEnumsOfTypes(gameModeData.activeResourceCardTypes);
        if (!isBankTradeMode && !isBeginnerMode) activeCards.push(CardEnum.AnyResource);
        return cardEnumsToCardState(activeCards);
    }, [
        gameModeData,
        isBankTradeMode,
        isBeginnerMode
    ]);
    const cardsToDisable = useMemo(()=>{
        var _beginnerActionState_resourceCardsPreventedFromTrading;
        return cardEnumsToCardState((_beginnerActionState_resourceCardsPreventedFromTrading = beginnerActionState === null || beginnerActionState === void 0 ? void 0 : beginnerActionState.resourceCardsPreventedFromTrading) !== null && _beginnerActionState_resourceCardsPreventedFromTrading !== void 0 ? _beginnerActionState_resourceCardsPreventedFromTrading : []);
    }, [
        beginnerActionState === null || beginnerActionState === void 0 ? void 0 : beginnerActionState.resourceCardsPreventedFromTrading
    ]);
    const cardsToHighlight = useCardsToHighlight(TradeErrorHighlightLocationEnum.WantedSelector);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.wantedCardSelectorContainer, className, {
            [styles.portraitLayout]: isPortraitLayout
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.cardsContainer
    }, /*#__PURE__*/ React.createElement(UIGameCardInventory, {
        showTipTitle: false,
        showTipBody: false,
        forceShowCardBadges: false,
        cardState: cardToDisplayState,
        enablePartition: false,
        onClickCard: handleAddCard,
        className: styles.cardStack,
        cardSize: isPortraitLayout ? 'xs' : 'base',
        cardsToHighlight: cardsToHighlight,
        cardsToSuggestion: shouldShowSuggestion ? wantedResourcesSuggestion : [],
        cardsToDisable: cardsToDisable
    })), /*#__PURE__*/ React.createElement(UIGameTradeCreatorBankRatio, {
        isPortraitLayout: isPortraitLayout
    }));
};
